export default "__VITE_ASSET__CzouX3D8__"